import{AsapAction as r}from"./AsapAction.js";import{AsapScheduler as o}from"./AsapScheduler.js";var p=new o(r),e=p;export{e as asap,p as asapScheduler};
